import { styled } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('div', {
    background: '$light-dark-1',
    display: 'flex',
    height: '48px',
    left: 0,
    padding: '$0',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 15,

    button: {
      '&.showSelector': {
        minWidth: '76px',
      },
    },
  }),

  PageSelectorWrapper: styled('div', {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'row',

    button: {
      '&.cancel': {
        marginLeft: '$3',
      },
    },
  }),

  Button: {
    background: 'transparent',
    width: '40px',
    height: '40px',
    color: '$actionNavigationStandardStatic',
  },

  BackButtonWrapper: styled('div', {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    minWidth: '100px',
    paddingLeft: '$1',
    order: 1,
  }),

  Options: styled('div', {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    minWidth: '100px',
    order: 3,
  }),

  RowReverse: styled('div', {
    display: 'flex',
    flexDirection: 'row-reverse',
  }),

  FlexContainer: styled('div', {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  }),
};
